const zarFormatter = new Intl.NumberFormat('en-ZA', {
  style: 'currency',
  currency: 'ZAR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const formatZar = (amount) => {
  const numericAmount = Number(amount)
  if (!Number.isFinite(numericAmount)) return 'R 0,00'
  return zarFormatter.format(numericAmount)
}
